import { i18n } from 'core/i18n';
var gmt2utc = function (dateTimeString) {
	return dateTimeString.replace(' ', 'T').replace('+0000', 'Z');
};
var formater = {
	newDate: function (dateTime) {
		if (typeof dateTime === 'string') {
			dateTime = gmt2utc(dateTime);
		}
		if (typeof dateTime === 'undefined') {
			return new Date();
		} else {
			return new Date(dateTime);
		}
	},
	price: function (num) {
		// var fNum = parseFloat(num).toFixed(5);
		if (num) {
			var fNum = parseFloat(num);
			if (fNum > 1000000) {
				fNum = fNum / 1000000;
			}
			fNum = parseFloat(num).toString();
			if (fNum.indexOf('.') === -1) {
				fNum += '.';
			}
			fNum += '0000000';
			fNum = fNum.substring(0, 7);
			return fNum;
		} else {
			return '';
		}
	},
	thousandComma: function (number) {
		if (number === 0) {
			return 0;
		} else if (!number) {
			return '';
		}
		let num = number.toString();
		num = num.replace(/,/g, '');
		const decimalPoint = num.indexOf('.') > -1;
		num = num.split('.');
		const pattern = /(-?\d+)(\d{3})/;
		while (pattern.test(num[0])) {
			num[0] = num[0].replace(pattern, '$1,$2');
		}
		if (decimalPoint) {
			num = num[0] + '.' + (num[1] || '');
		} else {
			num = num[0];
		}
		return num;
	},
	dateTime: function (dateTime, format) {
		format = format || 'yyyyMMdd hh:mm:ss';
		if (typeof dateTime === 'string') {
			dateTime = gmt2utc(dateTime);
		}
		var dateObj = new Date(dateTime);
		const weekdays = [
			i18n('format_weekdays_sunday'),
			i18n('format_weekdays_monday'),
			i18n('format_weekdays_tuesday'),
			i18n('format_weekdays_wednesday'),
			i18n('format_weekdays_thursday'),
			i18n('format_weekdays_friday'),
			i18n('format_weekdays_saturday')
		];
		var result = '',
			year = dateObj.getFullYear(),
			month = dateObj.getMonth() + 1,
			day = dateObj.getDate(),
			hour = dateObj.getHours(),
			minute = dateObj.getMinutes(),
			second = dateObj.getSeconds(),
			milliseconds = dateObj.getMilliseconds(),
			weekDay = weekdays[dateObj.getDay()];
		//month < 10 && (month = ('0' + month));
		// day < 10 && (day = '0' + day);

		if (month < 10) {
			month = ('0' + month);
		}
		if (day < 10) {
			day = '0' + day;
		}
		if (hour < 10) {
			hour = '0' + hour;
		}
		if (minute < 10) {
			minute = '0' + minute;
		}
		if (second < 10) {
			second = '0' + second;
		}
		if (milliseconds < 10) {
			milliseconds = '00' + milliseconds;
		} else if (milliseconds < 100) {
			milliseconds = '0' + milliseconds;
		}
		result = format.replace('yyyy', year.toString())
			.replace('MM', month.toString())
			.replace('dd', day.toString())
			.replace('hh', hour.toString())
			.replace('mm', minute.toString())
			.replace('ss', second.toString())
			.replace('ms', milliseconds.toString())
			.replace('day', weekDay);
		return result;
	},
	convertTimezone: function (date, timezone, offset) {
		var timeOffset = offset ? offset : 0;
		var currDate = (typeof date === 'string') ? new Date(gmt2utc(date)) : date;
		// convert to msec
		// add local time zone offset
		// get UTC time in msec
		var utc = currDate.getTime() + (currDate.getTimezoneOffset() * 60000);
		// create new Date object for different city
		// using supplied offset
		var nd = new Date(utc + (3600000 * timezone) + timeOffset);
		// return time as a string
		return nd;
	},
	newPriceFormat: function (priceNum) {
		if (priceNum) {
			const price = Math.round((priceNum * 10000)).toString();
			return price.slice(0, price.length - 4).replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + price.slice(-4);
		} else {
			return '';
		}
	},
	newDateTime: function (date, format) {
		if (date) {
			format = format || 'yyyy/mm/dd';
			let newDate = '';
			switch (format) {
				case 'yyyy/mm/dd':
					newDate = format.replace('yyyy', date.substr(0, 4)).replace('mm', date.substr(4, 2)).replace('dd', date.substr(6, 2));
					break;
				case 'yyyy/mm':
					newDate = format.replace('yyyy', date.substr(0, 4)).replace('mm', date.substr(4, 2));
					break;
				case 'mm/dd':
					newDate = format.replace('mm', date.substr(0, 2)).replace('dd', date.substr(2, 2));
					break;
				default:
					break;
			}
			return newDate;
		} else {
			return '';
		}

	},
	parseUrlEncode: function (url) {
		const chinese = url.substring(url.indexOf('pdf_file/') + 'pdf_file/'.length, url.indexOf('.pdf'));
		return url.replace(chinese, encodeURIComponent(chinese));
	},
	decimal: function (num, decimal) {
		decimal = decimal || 4;

		const newDecimal = Math.pow(10, decimal);
		return (Math.round(num * newDecimal) / newDecimal);
	},
	parsePosition(num, item) {
		// latitude 訪客所在緯度 (格式:xxx.xxx，請保持三碼.三碼)
		// longitude 訪客所在經度 (格式:xxxx.xxx，請保持四碼.三碼)
		let newNum = num.toString().split('.'),
			isNegative = num < 0,
			digit = item === 'longitude' ? 4 : 3,
			decimal = 3;

		if (newNum[0] && newNum[0].length < digit) {
			let digitZero = Math.pow(10, digit - newNum[0].length).toString().split('1')[1] || '';
			digitZero.toString();

			if (isNegative) {
				newNum[0] = '-'.concat(digitZero.concat(newNum[0].toString().split('-')[1]));
			} else {
				newNum[0] = digitZero.concat(newNum[0]);
			}
		}

		if (newNum[1]) {
			if (newNum[1].length < decimal) {
				let decinalZero = Math.pow(10, decimal - newNum[1].length).toString().split('1')[1] || '';
				decinalZero.toString();
				newNum[1] = newNum[1].concat(decinalZero);
			} else {
				newNum[1] = newNum[1].substr(0, 3);
			}
		} else {
			newNum[1] = '000';
		}

		return newNum[0].concat('.'.concat(newNum[1]));
	},
	countDate: function (interval, number, date, format = 'yyyyMMdd') {
		const newDate = new Date(date);
		switch (interval) {
			case 'y':
				newDate.setFullYear(date.getFullYear() - number);
				break;
			case 'm':
				newDate.setMonth(date.getMonth() - number);
				break;
			case 'w':
				newDate.setDate(date.getDate() - number * 7);
				break;
			case 'd':
				newDate.setDate(date.getDate() - number);
				break;
			default:
				newDate.setDate(date.getDate() - number);
				break;
		}

		return this.dateTime(newDate, format);
	},
	countTime: function (interval, startTime, endTime) {
		const startDate = new Date(startTime),
			endDate = new Date(endTime);

		switch (interval) {
			case 's':
				return parseInt((endDate - startDate) / 1000);
			case 'n':
				return parseInt((endDate - startDate) / 60000);
			case 'h':
				return parseInt((endDate - startDate) / 3600000);
			case 'd':
				return parseInt((endDate - startDate) / 86400000);
			case 'w':
				return parseInt((endDate - startDate) / (86400000 * 7));
			case 'm':
				return (new Date(endTime).getMonth() + 1) + ((new Date(endTime).getFullYear() - new Date(startTime).getFullYear()) * 12) - (new Date(startTime).getMonth() + 1);
			case 'y':
				return new Date(endTime).getFullYear() - new Date(startTime).getFullYear();
			default:
				return '';
		}
	},
	countTime1: function (startTime) {
		const startDate = new Date(startTime),
			endDate = new Date(),
			gap = endDate.getTime() - startDate.getTime(),
			days = Math.floor(gap / (24 * 3600 * 1000)),
			leave1 = gap % (24 * 3600 * 1000),
			hours = Math.floor(leave1 / (3600 * 1000)),
			leave2 = leave1 % (3600 * 1000),
			minutes = Math.floor(leave2 / (60 * 1000)),
			leave3 = leave2 % (60 * 1000),
			seconds = Math.round(leave3 / 1000);
		return `${days}${i18n('format_countTime_days')}${hours}${i18n('format_countTime_hours')}${minutes}${i18n('format_countTime_minutes')}${seconds}${i18n('format_countTime_seconds')}`;
	},
	countAge: function (birthDate, endDate) {
		const _birthDate = new Date(birthDate),
			_endDate = new Date(endDate);
		let age = _endDate.getFullYear() - _birthDate.getFullYear(),
			m = _endDate.getMonth() - _birthDate.getMonth();
		if (m < 0 || (m === 0 && _endDate.getDate() < _birthDate.getDate())) {
			age--;
		}
		return age;
	},
	paxType: function (type) {
		switch (type) {
			case 'ADT':
				return ('adult');
			case 'CHD':
				return ('child');
			case 'INF':
				return ('infant');
			default:
				return ('');
		}
	},
	paxTitle: function (title) {
		switch (title) {
			case 'MR':
				return (i18n('translation').mr);
			case 'MS':
				return (i18n('translation').ms);
			case 'MSTR':
				return (i18n('translation').master);
			case 'MISS':
				return (i18n('translation').miss);
			default:
				return ('');
		}
	},
	dateLength: function (year, month) {
		if (month < 10 && month.toString().length < 2) {
			month = '0' + month;
		}
		switch (month) {
			case '01':
			case '03':
			case '05':
			case '07':
			case '08':
			case '10':
			case '12':
				return 31;
			case '04':
			case '06':
			case '09':
			case '11':
				return 30;
			case '02':
				if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
					return 29;
				} else {
					return 28;
				}
			default:
				return '';
		}
	},
	productCode: function (productClass) {
		switch (productClass) {
			case 'B':
				return 'tigerlight';
			case 'M':
				return 'tigersmart';
			case 'F':
				return 'tigerpro';
			case 'C':
				return 'Code-share';
			default:
				return '';
		}
	},
	completeLocale: function (locale) {
		switch (locale) {
			case 'zh-tw':
			case 'zh':
			case 'zh_TW':
			case 'zh-TW':
				return 'zh-TW';
			case 'jp':
			case 'ja':
			case 'ja_JP':
			case 'ja-JP':
				return 'ja-JP';
			case 'kr':
			case 'ko':
			case 'ko_KR':
			case 'ko-KR':
				return 'ko-KR';
			case 'th':
			case 'th_TH':
			case 'th-TH':
				return 'th-TH';
			case 'en':
			case 'en_US':
			case 'en-US':
			default:
				return 'en-US';
		}
	}
};

export default formater;
